import { UserRole } from '@synergy/models';
import { UserStatus } from '@synergy/models';

import { Employee } from '../../features/user-management/models/employee';

export const getUserStatus = (contact: Employee): UserStatus => {
    if (!contact.user) {
        return UserStatus.NoUser;
    }

    if (!contact.user.isActivated) {
        return UserStatus.NotActivated;
    }

    if (contact.user.roles?.includes(UserRole.SupplierAdmin)) {
        return UserStatus.SupplierAdmin;
    }

    return UserStatus.SupplierUser;
};
